import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="app">
        {/* Navigation Header */}
        <header className="app-header">
          <div className="header-container">
           <Link to="/" className="logo">
  <img 
    src="/trocaaki-logo.png" 
    alt="TrocaAki Logo" 
    className="logo-image" 
  />
</Link>
            <nav className="main-nav">
              <Link to="/dashboard">Dashboard</Link>
              <Link to="/register">Register</Link>
              <Link to="/pay">Pay</Link>
              <Link to="/balance">Balance</Link>
              <Link to="/shops">Shops</Link>
              <Link to="/help">Help</Link>
            </nav>
            <div className="user-menu">
              <span className="user-greeting">Welcome!</span>
              <button className="btn-login">Login</button>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="app-main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            {/* We'll add more routes as we build them */}
          </Routes>
        </main>

        {/* Footer */}
        <footer className="app-footer">
          <div className="footer-container">
            <p>Copyright © TrocaAki - Powered by Ladilsa. All rights reserved.</p>
            <p className="footer-links">
              <a href="/privacy">Privacy Policy</a> | 
              <a href="/terms">Terms of Service</a> | 
              <a href="/contact">Contact Us</a>
            </p>
            <p className="version">Version 1.0.0 | Development Build</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

// Home Page Component
function HomePage() {
  const [backendStatus, setBackendStatus] = React.useState('Checking...');
  
    React.useEffect(() => {
    console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    console.log('NODE_ENV:', process.env.NODE_ENV);
    checkBackendConnection();
  }, []);

  React.useEffect(() => {
    checkBackendConnection();
  }, []);

  const checkBackendConnection = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://trocaaki-api.ladilsa.com';
	  const response = await fetch(`${apiUrl}/health`);
      const data = await response.json();
      
      if (data.healthy) {
        setBackendStatus('✅ Connected');
      } else {
        setBackendStatus('❌ Disconnected');
      }
    } catch (error) {
      setBackendStatus('❌ Connection Failed');
    }
  };

  return (
    <div className="home-page">
      <div className="hero-section">
        <h1>Welcome to TrocaAki</h1>
        <p className="tagline">Angola's Peer-to-Peer Payment Solution</p>
        <p className="description">
          Connect buyers and sellers across Angola. Send and receive payments instantly 
          with secure QR codes. No third parties, just direct transactions.
        </p>
        <div className="hero-buttons">
          <Link to="/dashboard" className="btn btn-primary btn-large">
            Go to Dashboard
          </Link>
          <Link to="/register" className="btn btn-outline btn-large">
            Register Your Shop
          </Link>
        </div>
      </div>

      <div className="status-section">
        <h2>System Status</h2>
        <div className="status-grid">
          <div className="status-item">
            <span>Frontend:</span>
            <span className="status-success">✅ Running</span>
          </div>
          <div className="status-item">
            <span>Backend API:</span>
            <span className={backendStatus.includes('✅') ? 'status-success' : 'status-error'}>
              {backendStatus}
            </span>
          </div>
          <div className="status-item">
            <span>Database:</span>
            <span className="status-success">✅ Connected</span>
          </div>
          <div className="status-item">
            <span>Mode:</span>
            <span className="status-warning">🛠️ Development</span>
          </div>
        </div>
      </div>

      <div className="features-section">
        <h2>Key Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">💰</div>
            <h3>Instant Payments</h3>
            <p>Send and receive money instantly between users</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>QR Code Payments</h3>
            <p>Scan QR codes to pay quickly and securely</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🏪</div>
            <h3>Shop Directory</h3>
            <p>Find and pay shops across Angola</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🏦</div>
            <h3>Bank Integration</h3>
            <p>Deposit and withdraw to your bank account</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;